<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>{{ 'Notification' | translate }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-item lines="none">
        <ion-textarea
            [(ngModel)]="message"
            [placeholder]="'Enter notification message' | translate"
            [autoGrow]="true"
            rows="3"
        ></ion-textarea>
    </ion-item>

    <ion-item lines="none">
        <ion-label>{{ 'Enable Notification' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="enabled" slot="end"></ion-toggle>
    </ion-item>

    <ion-item lines="none">
        <ion-label>{{ 'Text Uppercase' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="textUpperCase" slot="end"></ion-toggle>
    </ion-item>

    <ion-item lines="none">
        <ion-label>{{ 'Color' | translate }}</ion-label>
        <ion-input 
            [(ngModel)]="color" 
            [placeholder]="'e.g. #FF5733 or red' | translate"
            slot="end"
            style="text-align: right;">
        </ion-input>
    </ion-item>

    <ion-button 
        expand="block" 
        (click)="saveNotification()" 
        [disabled]="isSaving"
        style="margin-top: 20px;"
    >
        @if (isSaving) {
            <ion-spinner name="crescent"></ion-spinner>
        } @else {
            {{ 'Save' | translate }}
        }
    </ion-button>
</ion-content>
